import type { MyProfilePayload } from '../../../backend.d'
import { Signal, createRoot, createSignal } from 'solid-js'
import { addListener } from '../../../lib/event/event'
import { Nullable } from '../../../typescript'
import { profileValueUpdatedEvent } from './authProfileValue'
import getAuthProfileValueFromLocalStorage from './getAuthProfileValueFromLocalStorage'

addListener(profileValueUpdatedEvent, (newValue) => {
  signal[1](newValue)
})

const signal: Signal<Nullable<MyProfilePayload>> = createRoot(() => {
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Nullable<MyProfilePayload>>(getAuthProfileValueFromLocalStorage())

  return signal
})

export const [getAuthProfile, setAuthProfile] = signal

export default function createAuthProfileSignal() {
  return signal
}
